module.exports = {
  baseUrl: {
    dev: "https://order.cateraway.com/api/",
    pro: "https://order.cateraway.com/api/"
    // pro:"https://api-prod.cateraway.com"
  }
};
